/**
 * Hides a scheduled section once its end date passes in the browser.
 *
 * The visibility window is enforced server-side in Liquid; this covers pages
 * served from cache or left open past the end date. Markup:
 *   <element data-schedule-end="2026-11-30T23:59:00+01:00">
 */
(() => {
  // setTimeout overflows above ~24.8 days
  const MAX_TIMEOUT = 2147483647;

  const hide = (element) => {
    const section = element.closest(".shopify-section") || element;
    section.style.display = "none";
  };

  const init = () => {
    document.querySelectorAll("[data-schedule-end]").forEach((element) => {
      if (element.dataset.scheduleBound) return;
      element.dataset.scheduleBound = "true";

      const end = Date.parse(element.dataset.scheduleEnd);
      if (isNaN(end)) return;

      const remaining = end - Date.now();
      if (remaining <= 0) {
        hide(element);
      } else if (remaining < MAX_TIMEOUT) {
        setTimeout(() => hide(element), remaining);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
